import React, {Component} from 'react';
import {Tag} from 'antd';
import BukkuTooltip from '../Tooltip';
import {Trans} from "@lingui/macro";

export default class extends Component {
    render() {
        const {record} = this.props;

        return (
            record.types.map((item, key) => {
                let color, title, text;
                switch (item) {
                    case 'customer':
                        color = 'green';
                        text = 'C';
                        title = <Trans>Customer</Trans>;
                        break;
                    case 'supplier':
                        color = 'red';
                        text = 'S';
                        title = <Trans>Supplier</Trans>;
                        break;
                    case 'employee':
                        color = 'blue';
                        text = 'E';
                        title = <Trans>Employee</Trans>;
                        break;
                    default: color = ''; break;
                }

                return (
                    <BukkuTooltip
                        title={title}
                        // eslint-disable-next-line react/no-array-index-key
                        key={key}
                    >
                        <Tag color={color} key={item}>{ text }</Tag>
                    </BukkuTooltip>
                );
            })
        );
    }
}
